import { FC } from 'react';
import { Typography, theme } from 'antd';
import { useSnapshot } from 'valtio';

import FlexBox from '../../atoms/FlexBox';
import { formStore } from '../../../store';

const { Text } = Typography;

/**
 * FormNumberLabel
 *
 * Leading item of the `FormControl` bar: the open form's number. It used to be
 * rendered by `FormVersionSelect`, which pinned it to the dropdown; standing on
 * its own it can lead the identity run — number, type, then the controls.
 *
 * Reads a single leaf off the store snapshot, so a field-value write never
 * re-renders it. The box is `controlHeight` tall so the label centres against
 * the selects beside it, which the `alignStart` row in `FormControl` would
 * otherwise leave it floating above.
 */
const FormNumberLabel: FC = () => {
  const { token } = theme.useToken();
  const snap = useSnapshot(formStore.state);
  const formNumber = snap.form.data?.formNumber;

  return (
    <FlexBox
      noGrow
      style={{ height: token.controlHeight }}
    >
      <Text>{formNumber || ''}</Text>
    </FlexBox>
  );
};

export default FormNumberLabel;
